<template>
	<div>
		<div style="text-align: left;vertical-align: top;margin-top: 20px;" class="f-cb">
			<div style="text-align: left;margin-top: 10px;display: inline-block;" class="f-fl">
				<el-select v-model="value" placeholder="请选择" @change="protagonist">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="Genhead f-cb f-fl" style="padding: 20px 0; display: inline-block;margin-left: 20px;">
				<div class="f-fl">
					<p class="ID-box item"><span class="tit">IDcode编码：</span> <span class="context">{{ ID}} /   {{oneID!=''?oneID  +'.':''}}{{twoID}}</span> </p>
					<!--<p class="MA-box item"><span class="tit">码标：</span> <span class="context">{{value.split('|')[1]}}  /   {{oneID +'.'}}{{ twoID}}</span></p>-->
				</div>

			</div>
		</div>

		<div class="type-box f-cb" v-show="activeg === 0">

			<div class="basics-box f-cb f-fl">
				<i class="sign el-icon-caret-left" :style="{top:excursionY+'%'}"></i>
				<div class="describe-box left-box f-fl" v-for="(item,index) in describeData " :key='index' :class="{'againbk':identificationcount === index }" @click=" metads($event,item.typeID,index) ">
					<img :src="item.icon" class="icon" />
					<p class="tit ">{{item.title}}</p>
				</div>
			</div>

			<div class="roll">
				<el-button type="text" icon="el-icon-arrow-left" class="lslide" @click="excursionL" v-show=" Arrdata.length>1 ||rollSlide"></el-button>
				<el-button type="text" icon="el-icon-arrow-right" class="rslide" @click="excursionR" v-show=" Arrdata.length>1 ||rollSlide"></el-button>

				<div class="tired-box" ref="tiredBox">
					<!--,width:excursionW+'px'-->
					<div class="Kaku f-cb" :style="{marginLeft: excursion+'px',width:excursionW+'px'}">

						<el-card class="box-card " ref="DataCard">
							<div slot="header" class="clearfix">
								<span>请选择用途</span>

							</div>
							<div class="incision">
								<div class="box-con">
									<div v-for="(o,index) in Thecard.library" :key="index" class="text " :class="{'item':index === typeData.one} " @click="typeSelect(index,'one',o.id,'libraryone')">
										{{o.value }}
									</div>
								</div>
							</div>

						</el-card>
						<!--{{Arrdata]}}-->
						<el-card class="box-card f-fl" v-for="(item,indexs) in Arrdata" :key="indexs">
							<div slot="header" class="clearfix">
								请选择
								<span style="color: #f56c6c;display: inline-block;">
									{{indexs === 0?Thecard.library[typeData.one].value: Arrdata[indexs-1].datas[ Arrdata[indexs-1].label].value}}
										<!--Arrdata[indexs-1].datas[ Arrdata[indexs-1].label].value-->
								</span> 用途

							</div>
							<div class="incision">
								<div style="height: 400px;overflow: hidden;overflow-y: scroll; width: 236px;">

									<div v-for="(iten,index) in item.datas" :key='index' class="text" :class="{'item':index === item.label } " @click="addto({rowindex:indexs, index:index})">
										{{ iten.value }}
										<!--									{{item.label === index}}-->
									</div>
								</div>
							</div>
						</el-card>
					</div>
				</div>
			</div>
			<div style="margin-top: 10%;display: inline-block;">
				<!--<p class="fr-context">您选择了：<br/> {{ TypeContext}}</p>-->
				<el-button type="primary" @click="next" :disabled="Arrdata.length <= 0 ">去申请</el-button>
				<!--<p class="fr-context"></p>-->
			</div>

		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				options: [],
				ID: '', //单位主码
				value: '',
				oneID: '',
				currentTabComponent: 'succeed',
				tabPosition: 'left',
				typeData: {
					one: 0
				},
				excursion: 0,
				activeg: 0,
				describeData: [{
						icon: require('@/assets/imgs/object.png'),
						title: '标识物',
						typeID: 3

					},
					{
						icon: require('@/assets/imgs/matter.png'),
						title: '标识事',
						typeID: 2

					},
					{
						icon: require('@/assets/imgs/person.png'),
						title: '标识人',
						typeID: 1
					},

				],
				identificationcount: 0,
				Thecard: {
					library: [{
							value: '',
							id: '',
						}

					],

				},
				Arrdata: [],
				Arrcontext: '',
				excursionY: 5,
				//				excursionW: 600,
				rollSlide: false,

			};
		},
		//						if(this.$store.state.commonalityData.IdcodeUserId == '') {
		//							console.log('哈哈')
		//							this.$router.push({
		//								path: 'genreslip',
		//							})
		//							this.$store.commit('resist')
		//							
		//						}
		beforeRouteEnter(to, from, next) {
			next(vm => {
				console.log(vm.$store)
				if(!vm.$store.state.commonalityData.IdcodeUserId) {
					next('genreslip');
				}
			})
		},
		created() {
			if(this.$store.state.commonalityData.platformRole == 5) {
				//								this.$alert('个人用户暂不支持此功能！', '提示', {
				//									callback: (action, done) => {
				//										this.$router.go(-1)
				//									}
				//								});
				this.$router.push({
					path: 'genreslip',
				})
				this.$store.commit('resist', 5)

			} else {

				if(this.$store.state.commonalityData.IdcodeUserId != '') {
					this.$http.get(this.$api + '/categoryApply/getOrganUnit', {
						params: {
							organUnitID: this.$store.state.commonalityData.IdcodeUserId
						}
					}).then(res => {
						if(res.body.result === 1) {
							this.ID = res.body.entity.organunit_oid.substring(0, 4).replace("i.1.", "MA.156.").replace("i.86", "MA.156") + res.body.entity.organunit_oid.substring(4);
						}
					}, rej => {})
				}

				this.$http.get(this.$api + '/identificationApply/getIdentificationList', {}).then(res => {
					if(res.body.result === 1) {
						if(res.body.entity != '' || res.body.entity.length > 0) {
							this.options = res.body.entity.map((item, index) => {
								return {
									value: item.identification_ID + '|' + item.identification,
									label: item.identification
								}
							})
							this.value = this.options[0].value;
						}

					} else if(res.body.result === 503) {
						this.$router.push({
							path: 'genreslip',
						})
						this.$store.state.resistshow = true;
						this.$store.commit('resist', 503)
						this.$router.push({
							path: 'genreslip',
						})

						//						this.$alert('您还没有注册码标或您注册的码标正在审核，暂不能注册品类码标', '提示', {
						//							confirmButtonText: '注册码标',
						//							callback: action => {
						//								this.$router.push({
						//									path: 'productregister'
						//								})
						//							}
						//						});
						//
						//						if(this.$store.state.commonalityData.IdcodeUserId === '') {
						//							this.$alert('请完善信息再使用此功能', '提示', {
						//								confirmButtonText: '完善信息',
						//								callback: action => {
						//									if(action === 'confirm') {
						//										this.$router.push({
						//											path: 'perfect'
						//										})
						//									} else {
						//										this.$router.push({
						//											path: 'home'
						//										})
						//									}
						//								}
						//							});
						//						} 
					}
				}, rej => {
					this.$message.error('数据连接失败');
				})

				this.basics();

			}

		},
		computed: {
			excursionW() {
				return(this.Arrdata.length + 1) * 294;
			},
			twoID() {
				let {
					Arrdata
				} = this;
				if(Arrdata.length < 1) {
					return '';
				} else {
					if(Arrdata[Arrdata.length - 1].label === '') {
						return Arrdata[Arrdata.length - 2].datas[Arrdata[Arrdata.length - 2].label].cid
					} else {
						return Arrdata[Arrdata.length - 1].datas[Arrdata[Arrdata.length - 1].label].cid

					}
				}
			},
			twocoding() {
				let {
					Arrdata
				} = this;
				if(Arrdata.length < 1) {
					return '';
				} else {
					if(Arrdata[Arrdata.length - 1].label === '') {

						return Arrdata[Arrdata.length - 2].datas[Arrdata[Arrdata.length - 2].label].id

					} else {

						return Arrdata[Arrdata.length - 1].datas[Arrdata[Arrdata.length - 1].label].id

					}
				}
			},
		},
		methods: {
			metads(e, typeID, index) {
				this.identificationcount = index;
				if(index == 1) {
					this.excursionY = 40;
				} else if(index == 2) {
					this.excursionY = 70;

				} else {
					this.excursionY = 5;

				}

				this.basics({
					id: typeID
				})

			},
			typeSelect(index, row, parameterid, parameterrow) {
				this.typeData[row] = index;
				this.oneID = parameterid
				this.basicstype({
					id: parameterid,
					row: parameterrow
				})
			},
			next() {
				let {
					Arrdata
				} = this;
				if(Arrdata.length > 0) {

					//					类型分层
					let Typehierarchy = this.Thecard.library[this.typeData.one].value;
					Arrdata.forEach((item, index) => {
						//						console.log(Arrdata[index].label)
						Typehierarchy += Arrdata[index].label === '' ? '' : '>' + Arrdata[index].datas[Arrdata[index].label].value
					})

					//					参数带入下个页面

					this.$router.push({
						name: 'add',
						params: {
							topID: this.oneID,
							typeid: this.Thecard.library[this.typeData.one].id,
							categoryID: this.twocoding,
							categorycoding: this.twoID,
							MAgid: this.value.split('|')[0],
							MAgname: this.value.split('|')[1],
							IDcodegid: this.ID + '/' + this.oneID + '.' + this.twoID,
							Primitives: this.Thecard.library[this.typeData.one].value,
							Typehierarchy: Typehierarchy,
							subtype: Arrdata[Arrdata.length - 1].label === '' ? this.Arrdata[Arrdata.length - 2].datas[Arrdata[Arrdata.length - 2].label].value : this.Arrdata[Arrdata.length - 1].datas[Arrdata[Arrdata.length - 1].label].value
						}
					})

				} else {
					this.$message.error('请选择用途再申请!');
				}

			},
			excursionL() {
				if(this.excursion >= 0) {
					return false;
				} else {
					this.excursion = this.excursion + 298
				}

			},
			excursionR() {
				let {
					excursionW
				} = this;

				let cardinalNumber = this.excursionW - this.$refs.tiredBox.clientWidth;

				if(this.excursion < -cardinalNumber + 10) {
					return false;
				} else {
					this.excursion = this.excursion - 298
				}

			},
			basics({
				id = 3,
				row = 'library'
			} = {}) {
				this.$http.get(this.$api + '/baseData/getCodeUseListByType', {
					params: {
						typeId: id
					}
				}).then(res => {
					this.Arrdata = [];
					this.excursion = 0;
					this.typeData.one = 0;

					if(res.body.result === 1) {
						this.Thecard[row] = res.body.entity.map((item, index) => {
							return {
								value: item.codeusename,
								id: item.codeusecode,

							}
						})
					}

					this.rollSlide = false;

					return false;

				}, rej => { //					console.log(rej)
				})

			},
			basicstype({
				id,
				row
			}) {
				this.$http.get(this.$api + '/baseData/getFirstCategoryListByCodeUse', {
					params: {
						codeusecode: id
					}
				}).then(res => {

					let Datas;
					if(res.body.result === 1) {
						Datas = res.body.entity.map((item, index) => {
							return {
								value: item.industrycategoryname,
								id: item.industrycategory_id,
								cid: item.industrycategorycode
							}
						})
					}

					this.Arrdata = [];
					this.$set(this.Arrdata, 0, {
						label: 0,
						datas: Datas
					})
					//					this.excursionW = 294 + this.Arrdata.length * 294;
					//					this.rollSlide = this.$refs.roll.clientWidth < 294 + this.Arrdata.length * 294 ? true : false;

					//										console.log(this.$refs.roll.clientWidth < 600 + this.Arrdata.length * 300)
					if(res.body.result != 1) this.$message.error(res.body.message);
					return false;
				})
			},
			addto({
				rowindex,
				index
			}) {
				this.Arrdata[rowindex].label = index;
				//								console.log(rowindex )
				//				if( this.Arrdata[rowindex].label === index){
				//					return false;
				//				}else{
				this.$http.get(this.$api + '/baseData/getChildCategoryListByParentID', {
					params: {
						industrycategory_id_parent: this.Arrdata[rowindex].datas[index].id
					}
				}).then(res => {
					this.$set(this.Arrdata, rowindex + 1, {
						label: '',
						datas: ''
					})

					if(res.body.result === 1) {

						let Datas = res.body.entity.map((item, index) => {
							return {
								value: item.industrycategoryname,
								id: item.industrycategory_id,
								codeuse_id: item.codeuse_id,
								cid: item.industrycategorycode

								//
							}
						})

						//						this.$set(this.Arrdata, rowindex + 1, {
						//							label: '',
						//							datas: Datas
						//						})
						this.Arrdata[rowindex + 1].datas = Datas
						//						this.excursionW = 300 * this.Arrdata.length;

						this.Arrdata.splice(rowindex + 2, this.Arrdata.length - rowindex + 2, )
						this.excursion = this.Arrdata.length > 2 ? -298 : 0

					} else if(res.body.result === 0) {
						//						this.excursionW = 600 + this.Arrdata.length * 294;

						return false;

					} else if(res.body.result === 503) {

						//						console.log(this.Arrdata.length - rowindex + 2)
						this.Arrdata.splice(rowindex + 1, this.Arrdata.length - rowindex + 1, )
						//						this.excursionW = 600 + this.Arrdata.length * 294;

						//						this.$message.error(res.body.message);
						return false;

					} else {
						return false;

					}
					//					console.log(this.Arrdata.length * 294)
					//					this.excursionW = 294 + this.Arrdata.length * 294;
					//					this.rollSlide = this.$refs.roll.clientWidth < 294 + this.Arrdata.length * 294 ? true : false;
				})
				//				this.Arrdata.push()

			},
			protagonist(row) {
				//				console.log(row)
			}
		}
	};
</script>

<style lang="scss">
	/*.labelIcon{
	width: 200px;
	height: 200px;
	display: inline-block;
	border: solid red 1px;

}*/
	/*.el-tabs__item{

		height: auto !important;
	}*/
	
	.type-box {
		margin-top: 20px;
		.f-fr {
			/*border: solid red 1px;*/
			.fr-context {
				padding: 10px 0;
				font-size: 14px;
				/*max-width: 100px;*/
			}
		}
	}
	
	.genre-box {
		padding: 50px;
	}
	
	.roll {
		width: 70%;
		padding: 10px 45px;
		height: 502px;
		margin: 0 auto;
		margin-top: 0;
		/*padding-top: 80px;*/
		position: relative;
		overflow: hidden;
		.tired-box {
			/*width: 100%;*/
			overflow: hidden;
			overflow-x: scroll;
			display: block;
			.Kaku {
				display: block;
				padding: 0 0;
				transition: .1s;
			}
		}
		.rslide {
			top: 40%;
			right: 0;
			font-size: 40px;
			position: absolute;
		}
		.lslide {
			top: 40%;
			left: 0;
			font-size: 40px;
			position: absolute;
		}
	}
	
	.box-card {
		width: 260px;
		margin-right: 20px;
		/*border: solid red 1px;*/
		float: left;
		margin-bottom: 10px;
		.clearfix {
			text-align: left;
			span {
				font-size: 16px;
				display: inline-block;
				/*width: 100%;*/
				/*border: solid red;*/
				text-align: left;
			}
		}
		.incision {
			display: inline-block;
			width: 220px;
			/*border: solid red 1px;*/
			overflow: hidden;
		}
		.box-con {
			/*border: solid red 1px;*/
			height: 400px;
			overflow: hidden;
			/*width: 240px;*/
			overflow-y: scroll;
			width: 236px;
		}
		.text {
			/*border: solid red 1px;*/
			padding: 12px 0;
			/*width: 220px;*/
			/*height: 400px;*/
			/*overflow: hidden;*/
			/*width: 220px;*/
			/*overflow-y: scroll;*/
			/*transition: border-color .2s, background-color .2s, color .2s;*/
			color: #666;
			border-bottom: 1px solid #ebeef5;
			font-size: 14px;
			cursor: pointer;
			&:hover {
				background-color: #f2f2f2;
			}
		}
		.item {
			background-color: #f2f2f2;
		}
	}
	
	.basics-box {
		width: 100px;
		text-align: left;
		position: relative;
		border-right: solid #1b59a8 1px;
		.describe-box {
			margin-bottom: 20px;
			/*border: solid red 1px;*/
			cursor: pointer;
			margin: 12px 0;
			display: inline-block;
			text-align: center;
			.icon {
				width: 30px;
				height: 30px;
				border: solid 15px #f7f6f6;
				background-color: #f7f6f6;
			}
			.tit {
				font-size: 14px;
				color: #7c7d80;
				margin-top: 8px;
			}
		}
		.sign {
			white-space: nowrap;
			/*content:'';*/
			font-size: 20px;
			position: absolute;
			color: #1b59a8;
			/*vertical-align: bottom;*/
			padding: 0;
			height: 28%;
			border: none;
			/*color: #2C3E50;*/
			/*border-right: solid #1b59a8 1px;*/
			right: 0px;
			width: 13px;
			line-height: 300%;
			/*height: 20px;*/
			display: inline-block;
		}
	}
	
	.againbk {
		.icon {
			border: solid 15px #e3effd !important;
			background-color: #e3effd !important;
		}
	}
	
	.left-box {}
</style>